import useRentalEstimateUpdate from "features/subscriptions/datahooks/useRentalEstimateUpdate";
import type { InvoiceEstimate } from "features/subscriptions/types";
import { getCouponUpdateState } from "features/subscriptions/utils";

import type { Pricing, RentedSubscription } from "common/types";

export default function useRentalOrderEstimate({
  subscription,
  pricing,
  seatQuantity,
  couponAction,
  isEnabled = true,
}: {
  subscription: RentedSubscription | undefined;
  pricing: { plan: Pricing; addon: Pricing } | undefined;
  seatQuantity: number;
  couponAction: string | "remove" | undefined;
  isEnabled?: boolean;
}) {
  const couponUpdateState = getCouponUpdateState(couponAction);

  //the fallback values are never sent - the query is disabled without a subscription
  const { estimateUpdate, isLoadingEstimateUpdate, estimateUpdateError } =
    useRentalEstimateUpdate({
      subscriptionId: subscription?.id ?? "",
      count: seatQuantity,
      planPricingId: pricing?.plan.id,
      couponUpdateState,
      isEnabled: isEnabled && !!pricing && !!subscription,
    });

  let updateOrCreateEstimate: InvoiceEstimate;

  if (estimateUpdate) {
    updateOrCreateEstimate =
      estimateUpdate.invoice_estimate || estimateUpdate.next_invoice_estimate;
  }

  return {
    updateOrCreateEstimate,
    toPayNowEstimate: estimateUpdate,
    isLoadingEstimate: isLoadingEstimateUpdate,
    estimateError: estimateUpdateError,
  };
}
